export default __webpack_public_path__ + "images/drop-shadow.png?684fd289dc1a9a1919e4c2e17ff5081c";